import React, { FC } from "react";
import FilesActionGroup from "../FilesActionGroup/FilesActionGroup.js";
import CustomPopup from "components/Pages/Inbox/Popups/CustomPopup.js";
import { useActionList } from "hooks/useActionList.js";
import { useMail } from "contexts/mailContext/mailContext.js";

type FolderActionsDropDownProps = {
  folderId: string;
  showActions: boolean;
  topPos: number;
};

const FolderActionsDropDown: FC<FolderActionsDropDownProps> = ({
  folderId,
  showActions,
  topPos,
}) => {
  const { getMailSecurity } = useMail();

  const security = getMailSecurity();
  const defaultActionList = ["Download", "Share", "Collection", "RemoveFolder"];
  const filteredActionList = security?.previewFiles
    ? defaultActionList.filter((action) => action !== "Download")
    : defaultActionList;
  const actionList = useActionList({
    defaultActionList: filteredActionList,
    security,
  });

  return (
    <CustomPopup showState={showActions} topPosition={topPos || 20}>
      <div
        className="dropdown-folder-actions"
        onClick={(e) => e.stopPropagation()}
      >
        <FilesActionGroup
          actionList={actionList}
          folderId={folderId}
          withTitle={true}
          className=""
        />
      </div>
    </CustomPopup>
  );
};

export default FolderActionsDropDown;
